import * as Icons from "lucide-react";
import { Link } from "react-router-dom";
import { SOCIALS, LINKS, IMG } from "@/data/site";
import { LeadDialog } from "./LeadDialog";

const COLS = [
  { title: "Academy", links: [["Courses", "#courses"], ["Coaching", "#coaching"], ["Workshops", "#workshops"], ["Academy", "#academy"]] },
  { title: "Company", links: [["About", "#about"], ["Corporate Training", "#corporate"], ["Contact", "#contact"]] },
  { title: "Resources", links: [["Blog", LINKS.blog], ["AI Knowledge Hub", LINKS.blog], ["Free Resources", "#resources"], ["FAQ", "#faq"]] },
  { title: "Legal", links: [["Privacy Policy", "/privacy"], ["Terms", "/terms"], ["Refund Policy", "/refund"], ["Disclaimer", "/disclaimer"]] },
];

export const Footer = () => (
  <footer className="relative bg-ink border-t border-white/5 pt-20 pb-10" data-testid="footer">
    <div className="mx-auto max-w-7xl px-6 lg:px-10">
      <div className="grid gap-12 lg:grid-cols-5">
        <div className="lg:col-span-2">
          <div className="flex items-center gap-2.5">
            <img src={IMG.logo} alt="SuhaniEdge logo" className="h-10 w-10 rounded-xl object-cover ring-1 ring-white/10" />
            <span className="font-heading text-xl font-semibold text-white">Suhani<span className="text-brand-light">Edge</span></span>
          </div>
          <p className="mt-5 text-slate-400 max-w-xs">Practical AI education for the people building what's next.</p>
          <a href={LINKS.store} target="_blank" rel="noopener noreferrer" data-testid="footer-store-btn" className="mt-6 inline-flex items-center gap-2 rounded-full border border-brand/40 bg-brand/10 text-brand-light hover:bg-brand hover:text-white font-semibold px-5 py-2.5 text-sm transition-colors">
            <Icons.Store className="h-4 w-4" /> Visit the SuhaniEdge Store
          </a>
          <div className="mt-6 flex items-center gap-3">
            {SOCIALS.map((s) => {
              const Icon = Icons[s.icon] || Icons.Link;
              return (
                <a key={s.label} href={s.href} target="_blank" rel="noopener noreferrer" data-testid={`social-${s.label.toLowerCase()}`} aria-label={s.label}
                  className="flex h-10 w-10 items-center justify-center rounded-full border border-white/10 text-slate-400 hover:text-white hover:border-brand hover:bg-brand/10 transition-colors">
                  <Icon className="h-4 w-4" />
                </a>
              );
            })}
          </div>
        </div>
        {COLS.map((c) => (
          <div key={c.title}>
            <p className="font-heading text-sm font-semibold text-white uppercase tracking-wider">{c.title}</p>
            <ul className="mt-5 space-y-3">
              {c.links.map(([label, href]) => (
                <li key={label}>
                  {href.startsWith("http") ? (
                    <a href={href} target="_blank" rel="noopener noreferrer" className="text-sm text-slate-400 hover:text-brand-light transition-colors">{label}</a>
                  ) : href.startsWith("/") ? (
                    <Link to={href} className="text-sm text-slate-400 hover:text-brand-light transition-colors">{label}</Link>
                  ) : label === "Contact" ? (
                    <LeadDialog type="contact" trigger={<button className="text-sm text-slate-400 hover:text-brand-light transition-colors">{label}</button>} />
                  ) : label === "Corporate Training" ? (
                    <LeadDialog type="corporate" trigger={<button className="text-sm text-slate-400 hover:text-brand-light transition-colors">{label}</button>} />
                  ) : (
                    <a href={href} className="text-sm text-slate-400 hover:text-brand-light transition-colors">{label}</a>
                  )}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="mt-16 pt-8 border-t border-white/5 flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-sm text-slate-500">© {new Date().getFullYear()} SuhaniEdge. All rights reserved.</p>
        <p className="text-sm text-slate-500">Your Practical AI Edge.</p>
      </div>
    </div>
  </footer>
);
